import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

//@ts-ignore
//window.game2048 = {
//    conf: 'conf1'
//}
const app = createApp(App).use(store).use(router).mount("#app");